module.exports = __webpack_public_path__ + "img/account_home.0b12bab4.png";